import { Button, Flex } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { HighlightText } from '~/components/shared/HighlightText'
import { Size } from '~/types/ThemeTypes'

import { useContactsListItemStyle } from './componentStyles/ContactsListItem.style'

interface ContactsListItemProps {
  name: string
  searchTerm?: string
  index: number
  extension?: string
  isSelected?: boolean
  onClick?: (index: number) => void
}

export const ContactsListItem = ({
  name,
  searchTerm,
  index,
  extension,
  isSelected,
  onClick,
}: ContactsListItemProps) => {
  const styles = useContactsListItemStyle()

  // Extract layout properties from styles to apply as native props
  const containerLayoutProps = {
    alignItems: styles.container?.alignItems,
    justifyContent: styles.container?.justifyContent,
    height: styles.container?.height,
    width: styles.container?.width,
    padding: styles.container?.padding,
    mb: styles.container?.mb,
  }

  const content = useMemo(() => {
    return (
      <>
        <HighlightText
          lineClamp={1}
          css={styles.text}
          query={[searchTerm ?? '']}
        >
          {name}
        </HighlightText>
        {extension && (
          <ExtensionBadge
            size={Size.md}
            extension={extension}
            searchTerm={searchTerm}
          />
        )}
      </>
    )
  }, [name, extension])

  return (
    <Flex
      key={index}
      as={Button}
      data-active={isSelected ? true : undefined}
      css={styles.container}
      {...containerLayoutProps}
      onClick={() => onClick?.(index)}
    >
      {content}
    </Flex>
  )
}
